import { orderBy } from 'lodash';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect, useCallback, useState, useRef, useMemo } from 'react';
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { Box, Grid, Button, Skeleton, Container, Stack,Checkbox, ListItemText, Popover, Tabs, Tab, Typography, Menu, MenuItem, OutlinedInput, InputAdornment, Badge, TextField, FormHelperText, ButtonGroup, Avatar, Divider, List, TablePagination } from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getPostsInitial, getMorePosts } from '../../redux/slices/blog';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { BlogPostCard, BlogPostsSort, BlogPostsSearch } from '../../components/_dashboard/blog';
import { UserCard } from 'src/components/_dashboard/user/cards';
import AddProject from 'src/components/_dashboard/blog/AddProject';
import { capitalCase } from 'change-case';
import { MButton } from 'src/components/@material-extend';
import { Visibility, VisibilityOff,ViewList, ViewModule, ExpandMore, ExpandLess, KeyboardBackspaceOutlined, List as ListIcon } from '@material-ui/icons';
import ProductionControll from 'src/components/_dashboard/blog/ProductionControl';
import ProjectGrid from 'src/components/_dashboard/blog/ProjectGridList';
import ProjectList from 'src/components/_dashboard/blog/ProjectListView';
import axios from 'axios';
import { COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import useWorkSpaceOption from 'src/hooks/useWorkspaceOptions';
import { MobileDateRangePicker } from '@material-ui/lab';
import moment from 'moment';
import Scrollbar from 'src/components/Scrollbar';

// ----------------------------------------------------------------------

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

const applySort = (posts, sortBy) => {
  if (sortBy === 'latest') {
    return orderBy(posts, ['createdAt'], ['desc']);
  }
  if (sortBy === 'oldest') {
    return orderBy(posts, ['createdAt'], ['asc']);
  }
  if (sortBy === 'popular') {
    return orderBy(posts, ['view'], ['desc']);
  }
  return posts;
};

const SkeletonLoad = (
  <Grid container spacing={3} sx={{ mt: 2 }}>
    {[...Array(4)].map((_, index) => (
      <Grid item xs={12} md={3} key={index}>
        <Skeleton variant="rectangular" width="100%" sx={{ height: 200, borderRadius: 2 }} />
        <Box sx={{ display: 'flex', mt: 1.5 }}>
          <Skeleton variant="circular" sx={{ width: 40, height: 40 }} />
          <Skeleton variant="text" sx={{ mx: 1, flexGrow: 1 }} />
        </Box>
      </Grid>
    ))}
  </Grid>
);
//  
const SORT = [
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
  { id: 'new', label: 'Newest', color: '#54D62C' }, 
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'last_updated', label: 'Recently Updated', color: '#ffff00' },
];

export default function CommunityJobs() {
  const theme = useTheme()
  const { workSpaceTitle } = useWorkSpaceOption()
  const ref = useRef(null);
  const location = useLocation()
  const communityId = location.state && location.state?.id
  const communityName = location.state && location.state.name;
  const projectsClients = location.state && location.state.clients;
  const projectsClientsArray = projectsClients ? projectsClients.split(',').map(id => id.trim()) : [];
  const refcategory = useRef(null);
  const dispatch = useDispatch();
  const [types,setTypes]  = useState([])
  const [categories,setCategories]  = useState([])
  const [filters, setFilters] = useState('latest');
  const [filterName, setFilterName] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [currentTab, setCurrentTab] = useState('Pre-Production');
  const [renderCards, setRenderCards] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [add,setAdd] = useState(false)
  const [isEdit,setIsEdit] = useState(false)
  const [all,setAll] = useState(false)
  const [openType,setOpenType] = useState(false)
  const [openCategory,setOpencategory] = useState(false)
  const [data,setData] = useState([])
  const [singleProjectData,setSingleProjectData] = useState(null)
  const [filtered,setFiltered] = useState([])
  const [searchData,setSearchData] = useState([])
  const { posts, hasMore, index, step } = useSelector((state) => state.blog);
  const sortedPosts = applySort(posts, filters);
  const onScroll = useCallback(() => dispatch(getMorePosts()), [dispatch]);
  const [productionCount,setProductionCount] = useState(0)
  const [holdCount,setHoldCount] = useState(0)
  const [preCount,setPreCount] = useState(0)
  const [postCount,setPostCount] = useState(0)
  const [filteredInstallations,setFilteredInstallations] = useState([])
  const [filteredPickup,setFilteredPickup] = useState([])
  const [filteredShipping,setFilteredShipping] = useState([])
  const [filteredCompletedInstallations,setFilteredCompletedInstallations] = useState([])
  const [value, setValue] = useState('one')

  const refCommunities = useRef(null);
  const [communitiesOpen, setCommunitiesOpen] = useState(false);
  const [communitiesData, setCommunitiesData] = useState([]);
  const [filterCommunity, setFilterCommunity] = useState([communityId]);
  const [installations,setInstallations]=useState([])
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const refClients = useRef(null);
  const [clientOpen, setClientOpen] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [filterClient, setFilterClient] = useState([]);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const refUsers = useRef(null);
  const [usersOpen, setUsersOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  console.log('userData----', userData)
  const [filterUser, setFilterUser] = useState([]);
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [projectSearchTerm, setProjectSearchTerm] = useState('');
  const [jobClassSearchTerm, setJobClassSearchTerm] = useState('');
  const [jobTypesSearchTerm, setJobTypesSearchTerm] = useState('');
  const [sortOpen, setSortOpen] = useState(false);
  const refSort = useRef(null);
  const [sort,setSort]=  useState(SORT[1])
  const [filterDateValue,setFilterDateValue]=  useState([null, null]);
  const [dueData,setDueData] = useState(true)
  const openPopupTemp=localStorage.getItem("openProductionPopup")
  console.log('openPopupTemp===',openPopupTemp)
  const [openViewPage, setOpenViewPage] = useState(openPopupTemp||false);
  const [projectId, setProjectId] = useState('');
  const [projectName,setProjectName]=useState('')
  const [filterProjectType, setFilterProjectType] = useState('ALL');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [totalCount, setTotalCount] = useState(0);
  const refDepartments = useRef(null);
  const [departmentsOpen, setDepartmentsOpen] = useState(false);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [filterDepartment, setFilterDepartment] = useState([]);
  const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const removePopupData=()=>{
    setProjectId('');
    setProjectName('');
  }

  const  user  = JSON.parse(window.localStorage.getItem('user'))
  const explodedPermissions =user?.exploded_permissions
  const hasPermission  = explodedPermissions?.some(permission => ['View Jobs','Add Jobs','Edit Jobs','Activate/Deactivate Jobs','Delete Jobs'].includes(permission)) ? true : false

  // Debounce search term to prevent too many API calls
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(filterName);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [filterName]);

  // Reset page when filters change
  useEffect(() => {
    setPage(0);
  }, [debouncedSearchTerm, filterClient, filterUser, currentTab, all, types, categories, filterProjectType]);

  // NEW OPTIMIZED: Separate function to fetch filter data only once
  const fetchFilterData = async () => {
    try {
      const filterResponse = await axios.post(
        `${REST_API_END_POINT}project/get-project-filter-data`,
        {
          userType: { value: user.user_type },
          userId: { value: user.user_id },
          hasPermission
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      // Process communities data
      const fetchedCommunities = (filterResponse?.data?.community || []).map(
        (community) => ({
          ...community,
          // BACKUP: Original community count logic - commented out for backup
          // no_of_projects: (community.no_of_projects || 0) + (installationCounts[community.id] || 0)
        })
      );
      const othersCommunity = { id: 'other', name: 'Others' };
      fetchedCommunities.push(othersCommunity);

      setCommunitiesData((oldCommunities) =>
        fetchedCommunities.map((comm) => {
          const old = oldCommunities.find((o) => o.id === comm.id);
          return {
            ...comm,
            checked: old ? old.checked : false
          };
        })
      );

       //Departments
       let fetchedDepartments = (filterResponse?.data?.departments || [])
       const othersDepartment = { id: 'All', name: 'All' };
       // fetchedDepartments.unshift(othersDepartment);
       setDepartmentsData((oldDepartments) =>
         fetchedDepartments.map((dep) => {
           const old = oldDepartments.find((o) => o.id === dep.id);
           return {
             ...dep,
             checked: old ? old.checked : false
           };
         })
       );


      // Process clients data
      const fetchedClients = filterResponse?.data?.clients || [];
      setClientData((oldClients) =>
        fetchedClients.map((client) => {
          const old = oldClients.find((o) => o.id === client.id);
          return {
            ...client,
            checked: old ? old.checked : false
          };
        })
      );

      // Process user data
      const fetchedUsers = filterResponse.data.staffMembers || [];
      setUserData((oldUsers) =>
        fetchedUsers.map((user) => {
          const old = oldUsers.find((o) => o.id === user.id);
          return {
            ...user,
            checked: old ? old.checked : false
          };
        })
      );
    } catch (error) {
      console.error('Error fetching filter data:', error);
    }
  };

  useEffect(() => {
    // BACKUP: Original fetchData function - commented out for backup
    // const fetchData = async () => {
    //   setIsLoading(true);
    //   try {
    //     const fromDate = filterDateValue[0] ? moment(filterDateValue[0])?.format('YYYY-MM-DD') : null;
    //     const toDate = filterDateValue[1] ? moment(filterDateValue[1])?.format('YYYY-MM-DD') : null;
    //     const projectResponse = await axios.post(`${REST_API_END_POINT}project/get-all-projects`,
    //       {
    //         userType: { value: user.user_type },
    //         userId: { value: user.user_id },
    //         hasPermission,
    //         sort: sort.id,
    //         from:fromDate,
    //         to:toDate,
    //         dueData:dueData
    //       },
    //       {
    //         headers: {
    //           'Content-Type': 'application/json',
    //         },
    //       });

    //       const completedInstallations = projectResponse?.data?.completedInstallations;
    //       // Count installations per community
    //       const installationCounts = completedInstallations?.reduce((acc, installation) => {
    //         acc[installation.community] = (acc[installation.community] || 0) + 1;
    //         return acc;
    //       }, {});

    //       // Merge installation counts into community data
    //       const communities = projectResponse?.data?.community?.map(community => ({
    //         ...community,
    //         no_of_projects: (community.no_of_projects || 0) + (installationCounts[community.id] || 0)
    //       }));

    //       const othersCommunity = { id: 'other', name: 'Others' };
    //       if (communities) {
    //         console.log('projectResponse?.data?.community---------',projectResponse?.data?.community);
    //         console.log('communities---------',communities);
    //         setCommunitiesData([...communities, othersCommunity]);
    //       } else {
    //         setCommunitiesData([othersCommunity]);
    //       }

    //     setData(projectResponse.data.results);
    //     const inititialData = projectResponse.data.results?.filter(item => ((item.status === 1 || item.status === 0 ) && item.jobcost===0))
    //     console.log('inititialData------',inititialData);
    //     setFiltered(projectResponse.data.results.filter(item => ((item.status === 1 || item.status === 0 ) && item.jobcost===0)));
    //     // setFiltered(projectResponse.data.results.filter(item => item.status === 1 || item.status === 0));
    //     setSearchData(inititialData);
    //     // setSearchData(projectResponse.data.results.filter(item => item.status === 1 || item.status === 0));
    //     setInstallations(projectResponse.data.completedInstallations);
    //     console.log('dataaaaaaaaaaaaaaaaaaaaacompletedInstallations',projectResponse.data.completedInstallations)

    //     // const othersCommunity = { id: 'other', name: 'Others' };
    //     // if (projectResponse.data?.community) {
    //     //   setCommunitiesData([...projectResponse.data.community, othersCommunity]);
    //     // } else {
    //     //   setCommunitiesData([othersCommunity]);
    //     // }

    //     const categoryResponse = await axios.post(`${REST_API_END_POINT}project/get-all-project-categories`, {
    //       headers: {
    //         'Content-Type': 'application/json',
    //       },
    //     });

    //     if (categoryResponse.data.status === 1) {
    //       setTypes(categoryResponse.data.projectTypes.map(type => ({ ...type, checked: false })));
    //       setCategories(categoryResponse.data.projectCategories.map(category => ({ ...category, checked: false })));
    //     }


    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   } finally {
    //     setTimeout(() => {
    //       setIsLoading(false);
    //     }, 1000);
    //   }
    //   setRenderCards(false);
    // };
    // const fetchData = async () => {
    //   setIsLoading(true);
    //   try {
    //     const fromDate = filterDateValue[0]
    //       ? moment(filterDateValue[0])?.format('YYYY-MM-DD')
    //       : null;
    //     const toDate = filterDateValue[1]
    //       ? moment(filterDateValue[1])?.format('YYYY-MM-DD')
    //       : null;
    
    //     // 1) Fetch main project data
    //     const projectResponse = await axios.post(
    //       `${REST_API_END_POINT}project/get-all-projects`,
    //       {
    //         userType: { value: user.user_type },
    //         userId: { value: user.user_id },
    //         hasPermission,
    //         sort: sort.id,
    //         from: fromDate,
    //         to: toDate,
    //         dueData: dueData
    //       },
    //       {
    //         headers: {
    //           'Content-Type': 'application/json'
    //         }
    //       }
    //     );
    
    //     // (Optional) completedInstallations logic
    //     const completedInstallations = projectResponse?.data?.completedInstallations || [];
    //     const installationCounts = completedInstallations.reduce((acc, installation) => {
    //       acc[installation.community] = (acc[installation.community] || 0) + 1;
    //       return acc;
    //     }, {});
    
    //     // Merge installation counts into community data
    //     const fetchedCommunities = (projectResponse?.data?.community || []).map((community) => ({
    //       ...community,
    //       no_of_projects: (community.no_of_projects || 0) + (installationCounts[community.id] || 0)
    //     }));
    
    //     const othersCommunity = { id: 'other', name: 'Others' };
    //     fetchedCommunities.push(othersCommunity); // add "others" at the end
    
    //     // 2) Update local states for raw project data
    //     setData(projectResponse.data.results);
    //     setFiltered(
    //       projectResponse.data.results.filter(
    //         (item) => (item.status === 1 || item.status === 0) && item.jobcost === 0
    //       )
    //     );
    //     setSearchData(
    //       projectResponse.data.results.filter(
    //         (item) => (item.status === 1 || item.status === 0) && item.jobcost === 0
    //       )
    //     );
    //     setInstallations(projectResponse.data.completedInstallations || []);
    
    //     // 3) Fetch job classes, categories, etc.
    //     const categoryResponse = await axios.post(
    //       `${REST_API_END_POINT}project/get-all-project-categories`,
    //       {
    //         headers: {
    //           'Content-Type': 'application/json'
    //         }
    //       }
    //     );
    
    //     // 4) Merge newly fetched data with previously checked states
    //     //    so user selections persist on refetch.
    
    //     // ============ Communities ============
    //     setCommunitiesData((oldCommunities) =>
    //       fetchedCommunities.map((comm) => {
    //         // Find any old item with the same ID
    //         const old = oldCommunities.find((o) => o.id === comm.id);
    //         return {
    //           ...comm,
    //           // If old was found, reuse its `checked` value; else default to false
    //           checked: old ? old.checked : false
    //         };
    //       })
    //     );
    
    //     // ============ Types ============
    //     if (categoryResponse.data.status === 1) {
    //       const fetchedTypes = categoryResponse.data.projectTypes || [];
    
    //       setTypes((oldTypes) =>
    //         fetchedTypes.map((type) => {
    //           const old = oldTypes.find((o) => o.id === type.id);
    //           return {
    //             ...type,
    //             checked: old ? old.checked : false
    //           };
    //         })
    //       );
    
    //       // ============ Categories ============
    //       const fetchedCats = categoryResponse.data.projectCategories || [];
    
    //       setCategories((oldCats) =>
    //         fetchedCats.map((cat) => {
    //           const old = oldCats.find((o) => o.id === cat.id);
    //           return {
    //             ...cat,
    //             checked: old ? old.checked : false
    //           };
    //         })
    //       );
    //     }
    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //   } finally {
    //     setTimeout(() => {
    //       setIsLoading(false);
    //     }, 1000);
    //   }
    //   setRenderCards(false);
    // };
    const fetchData = async () => {
      if (isLoading) return; // Prevent multiple simultaneous calls
      setIsLoading(true);
      try {
        const fromDate = filterDateValue[0]
          ? moment(filterDateValue[0])?.format('YYYY-MM-DD')
          : null;
        const toDate = filterDateValue[1]
          ? moment(filterDateValue[1])?.format('YYYY-MM-DD')
          : null;
    
        const projectResponse = await axios.post(
          `${REST_API_END_POINT}project/get-all-projects`,
          {
            userType: { value: user.user_type },
            userId: { value: user.user_id },
            hasPermission,
            sort: sort.id,
            from: fromDate,
            to: toDate,
            dueData: false,
            filterProjectType: filterProjectType,
            currentTab: all ? 'ALL' : currentTab,
            page: page + 1, // Backend uses 1-based pagination
            limit: rowsPerPage,
            search: debouncedSearchTerm,
            jobClassFilter: types.filter(t => t.checked).map(t => parseInt(t.id, 10)),
            jobTypesFilter: categories.filter(c => c.checked).map(c => parseInt(c.id, 10)),
            clientFilter: filterClient.length > 0 ? filterClient.map(id => parseInt(id)) : [],
            userFilter: filterUser.length > 0 ? filterUser.map(id => parseInt(id)) : [],
            projectFilter: [communityId], // Only fetch projects for the current community
            departmentFilter: filterDepartment.length > 0 ? filterDepartment.map(id => parseInt(id)) : []
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
    
        // NEW OPTIMIZED: Only fetch results, completedInstallations, and pagination
        const completedInstallations = projectResponse?.data?.completedInstallations || [];
        const pagination = projectResponse?.data?.pagination || {};
        
        // Update pagination state - use correct count based on current tab
        if (['Installs', 'Pickup', 'Shipping', 'T & M Review', 'Cost Card', 'Completed'].includes(currentTab)) {
          // For installation tabs, use completedInstallations count
          setTotalCount(completedInstallations.length || 0);
        } else {
          // For regular project tabs, use regular pagination count
          setTotalCount(pagination.totalCount || 0);
        }
        
        const installationCounts = completedInstallations.reduce((acc, installation) => {
          acc[installation.community] = (acc[installation.community] || 0) + 1;
          return acc;
        }, {});
    
        const filteredProject = projectResponse.data.results.filter(
          (project) => project.status !== 3
        );
    
        // Update client data with project counts (only if clients already exist)
        if (clientData.length > 0) {
          setClientData((oldClients) =>
            oldClients.map((client) => ({
              ...client,
              no_of_projects: filteredProject.filter(
                (project) => project.customer_id === client.id
              ).length,
            }))
          );
        }
    
        const projects = projectResponse.data.results || [];
        const filteredProjects = projects.filter(
          (item) => (item.status === 1 || item.status === 0) && item.jobcost === 0
        );
    
        // Set counts for tabs
        const counts = {
          Production: 0,
          'Pre-Production': 0,
          'Post Production': 0,
          Hold: 0
        };
    
        projects.forEach((item) => {
          if (item.hold === 1) counts['Hold'] += 1;
          else if (item.status === 3 && item.hold === 0) counts['Post Production'] += 1;
          else if ((item.status === 1 || item.status === 0) && item.hold === 0)
            counts['Pre-Production'] += 1;
          else if (item.status !== 1 && item.status !== 3 && item.status !== 0 && item.hold === 0)
            counts['Production'] += 1;
        });
    
        const allProjects = projects?.filter(project => project?.community == communityId);
        setData(allProjects);
        setFiltered(filteredProjects);
        setSearchData(filteredProjects);
        setInstallations(completedInstallations);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
      setRenderCards(false);
    };
    
    
    fetchData();
  }, [renderCards, sort, filterDateValue, filterProjectType, page, rowsPerPage, debouncedSearchTerm, filterClient, filterUser, currentTab, all, types, categories,filterDepartment]);

  // NEW OPTIMIZED: Fetch filter data only once on component mount
  useEffect(() => {
    fetchFilterData();
  }, []); // Only run once on mount

  // Fetch categories and types only once on component mount
  useEffect(() => {
    const fetchCategoriesAndTypes = async () => {
      try {
        const categoryResponse = await axios.post(
          `${REST_API_END_POINT}project/get-all-project-categories`,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
    
        if (categoryResponse.data.status === 1) {
          const fetchedTypes = categoryResponse.data.projectTypes || [];
          setTypes((oldTypes) =>
            fetchedTypes.map((type) => {
              const old = oldTypes.find((o) => o.id === type.id);
              return {
                ...type,
                checked: old ? old.checked : false
              };
            })
          );
    
          const fetchedCats = categoryResponse.data.projectCategories || [];
          setCategories((oldCats) =>
            fetchedCats.map((cat) => {
              const old = oldCats.find((o) => o.id === cat.id);
              return {
                ...cat,
                checked: old ? old.checked : false
              };
            })
          );
        }
      } catch (error) {
        console.error('Error fetching categories and types:', error);
      }
    };

    fetchCategoriesAndTypes();
  }, []); // Only run once on mount
    
  //  useEffect(()=>{
  //    if(currentTab){
  //     const Data = data?.filter(item => {
  //       let variable = ''
  //       if(item.jobcost===1) variable = 'Hold'
  //       if(item.status !== 1 && item.status !== 3 && item.status !== 0 && item.jobcost===0) variable = 'Production'
  //       if((item.status === 1 || item.status === 0 )&& item.jobcost===0) variable = 'Pre-Production'
  //       if(item.status === 3 && item.jobcost===0) variable = 'Post Production'
  //       return variable === currentTab
  //     });
  //     if(currentTab === 'Production'){
  //       setFilterCommunity([])
  //       setProductionCount(Data?.length)
  //     }
  //     if(currentTab === 'Pre-Production'){
  //       setFilterCommunity([])
  //       setPreCount(Data?.length)
  //     }
  //     if(currentTab === 'Post Production'){
  //       setFilterCommunity([])
  //       setPostCount(Data?.length)
  //     }
  //     if(currentTab === 'Hold'){
  //       setFilterCommunity([])
  //        setHoldCount(Data?.length)
  //     }
  //     setFiltered(Data)
  //     setSearchData(Data)
  //    }
  //  },[currentTab,data])

  // useEffect(() => {
  //   if (data && installations) {
  //     const updateCounts = (filteredData, filteredInstallations, filteredCompletedInstallations) => {
  //       const counts = {
  //         'Production': 0,
  //         'Pre-Production': 0,
  //         'Post Production': 0,
  //         'Hold': 0,
  //         'Installs': filteredInstallations.length,
  //         'Completed': filteredCompletedInstallations.length
  //       };
  
  //       filteredData.forEach(item => {
  //         let variable = '';
  //         if (item.hold === 1) variable = 'Hold';
  //         if (item.status !== 1 && item.status !== 3 && item.status !== 0 && item.hold === 0) variable = 'Production';
  //         if ((item.status === 1 || item.status === 0) && item.hold === 0) variable = 'Pre-Production';
  //         if (item.status === 3 && item.hold === 0) variable = 'Post Production';
  
  //         if (variable) {
  //           counts[variable]++;
  //         }
  //       });
  
  //       setProductionCount(counts['Production']);
  //       setPreCount(counts['Pre-Production']);
  //       setPostCount(counts['Post Production']);
  //       setHoldCount(counts['Hold']);
  //     };
  
  //     // Filter data based on community selection
  //     const filteredByCommunity = data.filter(item => 
  //       filterCommunity.length === 0 || 
  //       filterCommunity.includes(item.community) || 
  //       (item.community === null && filterCommunity.includes('other'))
  //     );

  //     // Filter completed installations based on community selection
  //     const filteredInstallationsByCommunity = installations.filter(installation =>
  //       filterCommunity.length === 0 ||
  //       filterCommunity.includes(installation.community) ||
  //       (installation.community === null && filterCommunity.includes('other'))
  //     );
  
  //     const installationsTabData = filteredInstallationsByCommunity?.filter((item)=>{
  //       return item.allInstallationCompleted !== 1
  //     })
  //     const completedTabData = filteredInstallationsByCommunity?.filter((item)=>{
  //       return item.allInstallationCompleted === 1
  //     })
  //     if (currentTab === 'Installs') {
  //       setFiltered(installationsTabData);
  //     } else if (currentTab === 'Completed') {
  //       setFiltered(completedTabData);
  //     } else {
  //       setFiltered(filteredByCommunity);
  //     }
  //     // Update counts for the filtered data
  //     updateCounts(filteredByCommunity, installationsTabData, completedTabData);
  //     setFilteredInstallations(installationsTabData);
  //     setFilteredCompletedInstallations(completedTabData);
  
  //     // Set search data based on current tab
  //     if (currentTab) {
  //       if (currentTab === 'Installs') {
  //         setSearchData(installationsTabData);
  //       } else if (currentTab === 'Completed') {
  //         setSearchData(completedTabData);
  //       } else {
  //         const newData = filteredByCommunity.filter(item => {
  //           let variable = '';
  //           if (item.hold === 1) variable = 'Hold';
  //           if (item.status !== 1 && item.status !== 3 && item.status !== 0 && item.hold === 0) variable = 'Production';
  //           if ((item.status === 1 || item.status === 0) && item.hold === 0) variable = 'Pre-Production';
  //           if (item.status === 3 && item.hold === 0) variable = 'Post Production';
  //           return variable === currentTab;
  //         });
  //         setFiltered(newData);
  //         setSearchData(newData);
  //       }
  //     } 
  //     // else {
  //     //   setSearchData(filteredByCommunity);
  //     // }
  //   }
  // }, [currentTab, data, filterCommunity, installations]);

  // Handle data display and filtering for different tabs
  useEffect(() => {
    if (data && installations) {
      // Filter completed installations data for different tabs
      const filteredInstallationsByCommunity = installations.filter(item => {
        // Filter by community
        const communityMatch = item.community == communityId;
        
        // Apply other filters
        const clientMatch = filterClient.length === 0 ||
          filterClient.includes(item.customer_id) ||
          (item.customer_id === null && filterClient.includes('other'));

        const userMatch = filterUser.length === 0 ||
          (item.project_members && item.project_members.some(member => 
            filterUser.includes(member.staff_id)
          ));

        const categoryMatch = categories.some(cat => cat.checked) 
          ? categories.filter(cat => cat.checked).map(cat => cat.id).includes(item.project_category) 
          : true;

        const nameMatch = filterName
          ? (
              item.description?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.customer_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.job_category_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.job_class_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.community_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.doc_number?.toLowerCase().includes(filterName.toLowerCase()) ||
              item?.est_doc_number?.toLowerCase().includes(filterName.toLowerCase())
            )
          : true;

        return communityMatch && categoryMatch && nameMatch && clientMatch && userMatch;
      });

      // Sort by due date if enabled
      const sortedByDueDated = dueData
        ? filteredInstallationsByCommunity.sort((a, b) => new Date(a.installation_date) - new Date(b.installation_date))
        : filteredInstallationsByCommunity;

      // Filter data for different tabs
      const installationsTabData = sortedByDueDated.filter(item => item.allInstallationCompleted !== 1);
      const pickupTabData = sortedByDueDated.filter(item => item.allInstallationCompleted !== 1 && item.InstallCompleteStatus == 2);
      const shippingTabData = sortedByDueDated.filter(item => item.allInstallationCompleted !== 1 && item.InstallCompleteStatus == 3 && item.installationStatus != 5);
      const completedTabData = sortedByDueDated.filter(item => item.allInstallationCompleted === 1);

      // Set filtered installation data
      setFilteredInstallations(installationsTabData);
      setFilteredPickup(pickupTabData);
      setFilteredShipping(shippingTabData);
      setFilteredCompletedInstallations(completedTabData);

      // Set data based on current tab
      if (['Installs', 'Pickup', 'Shipping', 'T & M Review', 'Cost Card', 'Completed'].includes(currentTab)) {
        setFiltered(sortedByDueDated);
        setSearchData(sortedByDueDated);
      } else {
        setFiltered(data);
        setSearchData(data);
      }
    } else if (data) {
      // Set the data directly from backend for regular tabs
      setFiltered(data);
      setSearchData(data);
    }
  }, [data, installations, currentTab, communityId, filterClient, filterUser, categories, filterName, dueData]);

  // Update pagination count when tab changes
  useEffect(() => {
    if (['Installs', 'Pickup', 'Shipping', 'T & M Review', 'Cost Card', 'Completed'].includes(currentTab)) {
      // For installation tabs, use the filtered installation data count
      let count = 0;
      switch (currentTab) {
        case 'Installs':
          count = filteredInstallations.length;
          break;
        case 'Pickup':
          count = filteredPickup.length;
          break;
        case 'Shipping':
          count = filteredShipping.length;
          break;
        case 'T & M Review':
        case 'Cost Card':
        case 'Completed':
          count = filteredCompletedInstallations.length;
          break;
        default:
          count = 0;
      }
      setTotalCount(count);
    }
  }, [currentTab, filteredInstallations, filteredPickup, filteredShipping, filteredCompletedInstallations]);
  
  
  console.log('setFiltered----------',filtered);

  // useEffect(() => {
  //   if(filterName || types || categories || filterCommunity){
  //     setSearchData(filtered.filter(p => ((filterName ? p.name.toLowerCase().includes(filterName.toLowerCase()) : true) &&
  //       (types.filter(t => t.checked).length ? types.filter(t => t.checked).map(t => t.id).includes(p.project_type) : true) &&
  //       (categories.filter(t => t.checked).length ? categories.filter(t => t.checked).map(t => t.id).includes(p.project_category) : true) &&
  //       (communitiesData?.some(community => community.id === 'other' && community.checked) ?
  //         (p.community === null || p.community === 'other' || communitiesData.some(c => c.id === p.community && c.checked)) :
  //         (communitiesData?.filter(t => t.checked).length ? communitiesData?.filter(t => t.checked).map(t => t.id).includes(p.community) : true)
  //       )
  //     )));
  //     console.log("useEffect-communitiesData----", communitiesData);
  //     console.log("useEffect-filterName----", filterName);
  //     console.log("useEffect-types----", types);
  //     console.log("useEffect-categories----", categories);
  //     console.log("useEffect-filterCommunity----", filterCommunity);
  //   }
  // }, [filterName, types, categories, filterCommunity]);

  //  useEffect(()=>{
  //   if(filterName == ''){
  //     setSearchData(filtered);
  //   } else if(filterName != '' || types?.some(item=>item.checked) || categories?.some(item=>item.checked) || filterCommunity?.length > 0){
  //     setSearchData(filtered.filter(p=>((filterName ? p.name.toLowerCase().includes(filterName.toLowerCase()) : true) &&
  //     (types.filter(t=>t.checked).length ? types.filter(t=>t.checked).map(t=>t.id).includes(p.project_type) :  true) &&
  //     (categories.filter(t=>t.checked).length ? categories.filter(t=>t.checked).map(t=>Number(t.id)).includes(Number(p.project_category)) :  true) &&
  //     // (communitiesData?.filter(t => t.checked).length ? communitiesData?.filter(t => t.checked).map(t => t.id).includes(p.community) : true)
  //     (
  //       communitiesData?.some(community => community.id === 'other' && community.checked) ? 
  //       (p.community === null || p.community === 'other' || communitiesData.some(c => c.id === p.community && c.checked)) : 
  //       (communitiesData?.filter(t => t.checked).length ? communitiesData?.filter(t => t.checked).map(t => t.id).includes(p.community) : true)
  //     )
  //     )))

  //   }
  //  },[filterName,types,categories,filterCommunity])
  // useEffect(() => {
  //   // If no filters at all, just show everything in `filtered`.
  //   const noSearchText = !filterName || filterName.trim() === '';
  //   const noTypes = !types.some((t) => t.checked);
  //   const noCategories = !categories.some((c) => c.checked);
  //   const noCommunities = filterCommunity.length === 0;
  
  //   if (noSearchText && noTypes && noCategories && noCommunities) {
  //     // No filters at all -> show everything
  //     setSearchData(filtered);
  //     return;
  //   }
  
  //   // Otherwise, do a combined filter pass
  //   const newData = filtered.filter((p) => {
  //     // --- 1) NAME MATCH ---
  //     const nameMatch = filterName
  //       ? p.name?.toLowerCase().includes(filterName.toLowerCase())
  //       : true;
  
  //     // --- 2) JOB TYPE MATCH ---
  //     const activeTypes = types
  //       .filter((t) => t.checked)
  //       .map((t) => Number(t.id));
  //     // If no job types are checked, it's automatically true
  //     const typeMatch = activeTypes.length > 0
  //       ? activeTypes.includes(Number(p.project_type))
  //       : true;
  
  //     // --- 3) JOB CATEGORY MATCH ---
  //     const activeCategories = categories
  //       .filter((c) => c.checked)
  //       .map((c) => Number(c.id));
  //     // If no categories are checked, automatically true
  //     const categoryMatch = activeCategories.length > 0
  //       ? activeCategories.includes(Number(p.project_category))
  //       : true;
  
  //     // --- 4) COMMUNITY MATCH ---
  //     // If no communities are selected, automatically true
  //     let communityMatch = true;
  //     if (filterCommunity.length > 0) {
  //       // If "other" is selected and p.community is null or "other", that is a match
  //       if (filterCommunity.includes('other') && 
  //           (p.community === null || p.community === 'other')) {
  //         communityMatch = true;
  //       } else {
  //         // Otherwise, we see if p.community is in the array
  //         communityMatch = filterCommunity.includes(p.community);
  //       }
  //     }
  
  //     // Only if ALL are true, we keep this item
  //     return nameMatch && typeMatch && categoryMatch && communityMatch;
  //   });
  
  //   setSearchData(newData);
  //   console.log('fdsfjsdfjsdf',newData)
  //   setFiltered(newData);
  // }, [filterName, filtered, types, categories, filterCommunity]);
  
  // Search filtering is now handled by the backend, so we just use the filtered data directly
  useEffect(() => {
      setSearchData(filtered); 
  }, [filtered]);
  

   const handleFetchEditData = useCallback((id) => {
    try {
      const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/get-project-by-id`,{ id: { value: id}, userId:user.user_id, userType: user.user_type  },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setSingleProjectData(response.data)
      
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }, [isEdit]);


  const ACCOUNT_TABS = [
    {
      value: 'Hold',
      count:holdCount||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/super.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/super.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/super.png'} projectData={searchData} communityJob={true}/>,
    },
    {
      value: 'Pre-Production',
      count:preCount||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/super.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/super.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/super.png'} projectData={searchData} communityJob={true}/>,
    },
    {
      value: 'Production',
      count:productionCount||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/great.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/great.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData}  projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/great.png'} projectData={searchData} communityJob={true}/>,
    },
    // {
    //   value: 'Post Production',
    //   count:postCount||0,
    //   component:<ProductionControll isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData}/>,
    //   listComponent:<ProjectList isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData}/>,
    //   GridListComponent:<ProjectGrid isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData}/>,
    // },
    {
      value: 'Installs',
      count:filteredInstallations.length||0,
      // count:installations?.length||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
    },
    {
      value: 'Pickup',
      count:filteredPickup.length||0,
      // count:installations?.length||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true} />,
    },
    {
      value: 'Shipping',
      count:filteredShipping?.length||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
    },
    {
      value: 'T & M Review',
      count:filteredCompletedInstallations?.length||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
    },
    {
      value: 'Cost Card',
      count:filteredCompletedInstallations?.length||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
    },
    {
      value: 'Completed',
      count:filteredCompletedInstallations?.length||0,
      component:<ProductionControll removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      listComponent:<ProjectList removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
      GridListComponent:<ProjectGrid removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} communityJob={true}/>,
    },
  ];

  useEffect(() => {
    dispatch(getPostsInitial(index, step));
  }, [dispatch, index, step]);

  const handleChangeSort = (event) => {
    setFilters(event.target.value);
  };
  const handleClick =()=>{
    setAll(!all)
    localStorage.setItem('all_project',all)
    setFilterUser([])
    setFilterClient([])
    setFilterCommunity([])
  }
  const handleChangeTab = (event, newValue) => {
    if (newValue === 'Completed') {
      setDueData(false);
    } else {
      setDueData(true);
    }
    setProjectId("");
    setProjectName("");
    setCurrentTab(newValue);
    // setRenderCards(!renderCards);
    // setFilterName('');
  };
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const CustomTab = styled(Tab)(({ theme }) => ({
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    boxShadow: 'none', //theme.shadows[5],
    minHeight: 'fit-content',
    indicator: {
      display: 'none',
    },
    height: 38,
    fontSize: 12,
    borderRadius: 'none', //20
    border: '1.5px solid #00c2ff', //newlyadded
    background: '#161c24',
    margin: 0, //5
    color: theme.palette.text.primary,
    '&:hover': {
      background: '#161c24',
    },
    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
    '&:first-child': {
      borderRadius: '7px 0 0 7px',
      borderLeft: `1.5px solid ${theme.palette.primary.main}`,
    },
    '&:nth-child(2)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:nth-child(3)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:last-child': {
      borderRadius: '0 7px 7px 0',
      borderLeft: '0',
    },
  
    [theme.breakpoints.up('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: `0 !important`,
      minWidth: '30.33% !important',
    },
  }))
  const handleChangeSortJobs = (category) => {
    setSort(category);
    setSortOpen(false);
  };

  const handleByDue =()=>{
    setDueData(!dueData)
  }

  const toggleType = (typeId) => {
    setTypes((prev) =>
      prev.map((type) =>
        type.id === typeId ? { ...type, checked: !type.checked } : type
      )
    );
  };
  const toggleCategory = (catId) => {
    setCategories((prev) =>
      prev.map((c) =>
        c.id === catId ? { ...c, checked: !c.checked } : c
      )
    );
  };

  const toggleCommunity = (commId) => {
    setCommunitiesData((prev) =>
      prev.map((c) =>
        c.id === commId ? { ...c, checked: !c.checked } : c
      )
    );
        // Then also manage the “filterCommunity” array
        setFilterCommunity((prev) =>
          prev.includes(commId)
            ? prev.filter((id) => id !== commId) // remove
            : [...prev, commId] // add
        );
      };

      const toggleDepartment = (depId) => {
        setDepartmentsData((prev) =>
          prev.map((c) =>
            c.id === depId ? { ...c, checked: !c.checked } : c
          )
        );
            // Then also manage the "filterDepartment" array
            setFilterDepartment((prev) => {
              const newFilter = prev.includes(depId)
                ? prev.filter((id) => id !== depId) // remove
                : [...prev, depId]; // add
              return newFilter;
            });
       };

      const toggleClient = (commId) => {
        setClientData((prev) =>
          prev.map((c) =>
            c.id === commId ? { ...c, checked: !c.checked } : c
          )
        );
            setFilterClient((prev) =>
              prev.includes(commId)
                ? prev.filter((id) => id !== commId)
                : [...prev, commId]
            );
          };

          const toggleUser = (userId) => {
            setUserData((prev) =>
              prev.map((u) =>
                u.id === userId ? { ...u, checked: !u.checked } : u
              )
            );
            setFilterUser((prev) =>
              prev.includes(userId)
                ? prev.filter((id) => id !== userId)
                : [...prev, userId]
            );
          };

    const wordCount = filterName?.trim().split(/\s+/).filter(Boolean).length || 0;
    const isOverLimit = wordCount > 25;

  const handleFilterProjectType = (type) => {
	  setFilterProjectType(type);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Page title={`${workSpaceTitle} | ${COMPANY_NAME}`}>
      <Container>
        <Button
            variant="outlined"
            type="submit"
            onClick={() => window.history.back()}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
                <Stack>
                <KeyboardBackspaceOutlined />
                </Stack>

            }
            >
            Back
        </Button>
        <HeaderBreadcrumbs
          heading={add ? `Add ${workSpaceTitle}` : isEdit ? `Edit ${workSpaceTitle}` : `${communityName} - All ${workSpaceTitle}`}
          links={[
            { name: 'Job Class', href: PATH_DASHBOARD.root },
            { name: 'Job Types', href: PATH_DASHBOARD.blog.root },
            { name: 'Posts' }
          ]}
          action={
            ((!add && !isEdit) && <Stack direction={'row'} spacing={2}>
              {/* <Button
                disabled={explodedPermissions?.some(permission => ['Add Jobs'].includes(permission)) ? false : true}
                variant="contained"
                onClick={()=>{setAdd(true)}}
                sx={{ height: 38 }}
                // component={RouterLink}
                // to={PATH_DASHBOARD.blog.newPost}
                startIcon={<Icon icon={plusFill} />}
              >
              {`Add ${workSpaceTitle}`}
              </Button> */}
              {!all && <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="none"
                aria-label="secondary tabs example"
              >
                <CustomTab value="one" icon={<ViewModule />} />
                <CustomTab value="two" icon={<ViewList  />}/>
                <CustomTab value="three" icon={<ListIcon />} />
              </Tabs>}
            </Stack>)
          }
        />
       <Box sx={{ mb: 2, mt: -2, display: 'flex', justifyContent: 'flex-start', boxShadow: 'none' }}>
          <ButtonGroup variant="outlined">
              <Button
                  startIcon={<Stack className='si--projects-alt-duotone' />}
                  variant={filterProjectType === 'ALL' ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none' }}
                  onClick={() => handleFilterProjectType('ALL')}
                  >
                    All
                  </Button>
                  <Button
                  startIcon={<Stack className='carbon--traffic-flow' />}
                  variant={filterProjectType === 1 ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none' }}
                  onClick={() => handleFilterProjectType(1)}
                  >
                    TS
                  </Button>
                  <Button
                  startIcon={<Stack className='fluent--production-checkmark-20-regular' />}
                  variant={filterProjectType === 2 ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none' }}
                  onClick={() => handleFilterProjectType(2)}
                  >
                    PS
                  </Button>
                  {/* <Button
                  startIcon={<Stack className='uil--file-info-alt' />}
                  variant={filterProjectType === 'NULL' ? 'contained' : 'outlined'}
                  sx={{ boxShadow: 'none' }}
                  onClick={() => handleFilterProjectType('NULL')}
                  >
                    Others
              </Button> */}
          </ButtonGroup>
        </Box>
        {(!add && !isEdit) ?
        (<>
        <Stack mb={2} spacing={{ xs: 3, sm: 2 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} alignItems="flex-end" justifyContent='flex-end'>
            {!all &&
              <>
            

                {/* <Button ref={refCommunities} onClick={() => setCommunitiesOpen(prevState => !prevState)} 
                        variant="outlined"
                        type="submit"
                        endIcon={
                          <Stack>
                            {communitiesOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                          </Stack>
                        }
                      >
                        Filter Project
                </Button> */}
                {/* <Menu
                  open={Boolean(communitiesOpen)}
                  anchorEl={refCommunities.current}
                  onClose={() => setCommunitiesOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%', maxHeight: '250px' }
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <List style={{ maxHeight: '250px', overflowY: 'auto' }}>
                    {communitiesData?.map((type) => (
                      <MenuItem key={type.id} >
                        <Checkbox
                          // checked={type.checked ? type.checked : false}
                          // onChange={() => {
                          //   const updatedType = [...communitiesData];
                          //   const item = updatedType.find((item) => item.id === type.id);
                          //   if (item) {
                          //     item.checked = !item.checked;
                          //     setCommunitiesData(updatedType);
                          //     setFilterCommunity((prevIds) => {
                          //       if (item.checked) {
                          //         return [...prevIds, item.id];
                          //       } else {
                          //         return prevIds.filter((id) => id !== item.id);
                          //       }
                          //     });
                          //   }
                          // }}
                          checked={!!type.checked}
                            onChange={() => toggleCommunity(type.id)}
                        />
                        {type.id === 'other' ?
                          <ListItemText primary={`${type.name}`} />
                        :
                          <ListItemText primary={`${type.name} (${type.no_of_projects})`} />
                        }
                      </MenuItem>
                    ))}
                    </List>
                </Menu> */}
              </>
            }
            {!all && 
                <>
                  <Button ref={refClients} onClick={() => setClientOpen(prevState => !prevState)} 
                          variant="outlined"
                          type="submit"
                          endIcon={
                            <Stack>
                              {clientOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                            </Stack>
                          }
                        >
                          Filter By Client
                  </Button>
                  <Menu
                    open={Boolean(clientOpen)}
                    anchorEl={refClients.current}
                    onClose={() => setClientOpen(false)}
                    PaperProps={{
                      sx: { width: 'auto', maxWidth: '100%' }
                    }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    <Box sx={{ p: 2, pb: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Search clients..."
                        value={clientSearchTerm}
                        onChange={(e) => setClientSearchTerm(e.target.value)}
                        fullWidth
                        variant="outlined"
                        sx={{ 
                          mb: 1,
                        }}
                      />
                      <Divider sx={{ mt: 2 }} />
                    </Box>
                    <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                      {(() => {
                        const filteredClients = clientData
                          ?.filter(type => type.id && projectsClientsArray.includes(String(type.id))) // 🔹 Filter By Client based on projectsClientsArray
                          ?.filter((type) =>
                            type.name?.toLowerCase().includes(clientSearchTerm.toLowerCase())
                          ) || [];
                        
                        if (filteredClients.length === 0 && clientSearchTerm) {
                          return (
                            <MenuItem disabled sx={{ justifyContent: 'center' }}>
                              <ListItemText 
                                primary="No result found" 
                                sx={{ textAlign: 'center' }}
                              />
                            </MenuItem>
                          );
                        }
                        
                        return filteredClients.map((type) => (
                          <MenuItem key={type.id}>
                            <Checkbox
                              checked={!!type.checked}
                              onChange={() => toggleClient(type.id)}
                            />
                            <Avatar 
                              src={type.thumbnail || type.profile_pic} 
                              alt={type.name}
                              sx={{ width: 32, height: 32, mr: 2 }}
                            >
                              {type.name ? type.name.charAt(0).toUpperCase() : '?'}
                            </Avatar>
                            {type.id === 'other' ? (
                              <ListItemText primary={`${type.name}`} />
                            ) : (
                              <ListItemText primary={`${type.name}`} />
                            )}
                          </MenuItem>
                        ));
                      })()}
                    </List>
                  </Menu>
                </>
              }
            {!all &&
              <>
                <Button ref={refUsers} onClick={() => setUsersOpen(prevState => !prevState)} 
                        variant="outlined"
                        type="submit"
                        endIcon={
                          <Stack>
                            {usersOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                          </Stack>
                        }
                      >
                        Filter By User
                </Button>
                <Menu
                  open={Boolean(usersOpen)}
                  anchorEl={refUsers.current}
                  onClose={() => setUsersOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%', }
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <Box sx={{ p: 2, pb: 1 }}>
                    <TextField
                      size="small"
                      placeholder="Search users..."
                      value={userSearchTerm}
                      onChange={(e) => setUserSearchTerm(e.target.value)}
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mb: 1,
                      }}
                    />
                    <Divider sx={{ mt: 1 }}/>
                  </Box>
                  <Box style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {(() => {
                      const filteredUsers = userData?.filter((user) => {
                        const searchText = userSearchTerm.toLowerCase();
                        const userName = (user.userName || user.person_name || user.name || user.email || '').toLowerCase();
                        return userName.includes(searchText);
                      }) || [];
                      
                      if (filteredUsers.length === 0 && userSearchTerm) {
                        return (
                          <MenuItem disabled sx={{ justifyContent: 'center' }}>
                            <ListItemText 
                              primary="No result found" 
                              sx={{ textAlign: 'center' }}
                            />
                          </MenuItem>
                        );
                      }
                      
                      return filteredUsers.map((user) => (
                        <MenuItem key={user.id}>
                          <Checkbox
                            checked={!!user.checked}
                            onChange={() => toggleUser(user.id)}
                          />
                          <ListItemText primary={`${user.userName || user.person_name || user.name || user.email}`} />
                        </MenuItem>
                      ));
                    })()}
                  </Box>
                </Menu>
              </>
            }
            <Button variant='outlined' onClick={handleClick}>
              All Jobs {all ?(<Visibility sx={{ml:1}}/>):(<VisibilityOff sx={{ml:1}}/>)}
            </Button>
            {/* <BlogPostsSearch /> */}
            {/* </Stack>
            <Stack direction={'row'} spacing={1}> */}
          
            {/* </Stack>         
            <Stack> */}

          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} alignItems="center" justifyContent="flex-end">
          {!all &&
              <>
            

                <Button ref={refDepartments} onClick={() => setDepartmentsOpen(prevState => !prevState)} 
                        variant="outlined"
                        type="submit"
                        endIcon={
                          <Stack>
                            {departmentsOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                          </Stack>
                        }
                      >
                        Filter By Department
                </Button>
                <Menu
                  open={Boolean(departmentsOpen)}
                  anchorEl={refDepartments.current}
                  onClose={() => setDepartmentsOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%' }
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <Box sx={{ p: 2, pb: 1 }}>
                    <TextField
                      size="small"
                      placeholder="Search departments..."
                      value={departmentSearchTerm}
                      onChange={(e) => setDepartmentSearchTerm(e.target.value)}
                      fullWidth
                      variant="outlined"
                      sx={{ 
                        mb: 1,
                      }}
                    />
                    <Divider sx={{ mt: 1 }}/>
                  </Box>
                  <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {(() => {
                      const filteredDepartments = departmentsData?.filter((type) =>
                        type.name?.toLowerCase().includes(departmentSearchTerm.toLowerCase())
                      ) || [];
                      
                      if (filteredDepartments.length === 0 && departmentSearchTerm) {
                        return (
                          <MenuItem disabled sx={{ justifyContent: 'center' }}>
                            <ListItemText 
                              primary="No result found" 
                              sx={{ textAlign: 'center' }}
                            />
                          </MenuItem>
                        );
                      }
                      
                      return filteredDepartments.map((type) => (
                        <MenuItem key={type.id} >
                          <Checkbox
                            checked={!!type.checked}
                              onChange={() => toggleDepartment(type.id)}
                          />
                          {type.id === 'All' ?
                            <ListItemText primary={`${type.name}`} />
                          :
                            <ListItemText primary={`${type.name}`} />
                          }
                        </MenuItem>
                      ));
                    })()}
                  </List>
                </Menu>
              </>
            }
              {!all &&
              <>
              <Button variant='outlined' ref={ref} onClick={()=>setOpenType(!openType)}>
              Job Class
              </Button>
              <Menu       
              open={Boolean(openType)}
              anchorEl={ref.current}
              onClose={()=>setOpenType(false)}
              PaperProps={{
                sx: { minWidth: 50, maxWidth: '100%' }
              }}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Box sx={{ p: 2, pb: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Search job classes..."
                    value={jobClassSearchTerm}
                    onChange={(e) => setJobClassSearchTerm(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ 
                      mb: 1,
                    }}
                  />
                  <Divider sx={{ mt: 1 }}/>
                </Box>
                <Box style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {(() => {
                    const filteredTypes = types?.filter((type) =>
                      type.name?.toLowerCase().includes(jobClassSearchTerm.toLowerCase())
                    ) || [];
                    
                    if (filteredTypes.length === 0 && jobClassSearchTerm) {
                      return (
                        <MenuItem disabled sx={{ justifyContent: 'center' }}>
                          <ListItemText 
                            primary="No result found" 
                            sx={{ textAlign: 'center' }}
                          />
                        </MenuItem>
                      );
                    }
                    
                    return filteredTypes.map((type) => (
                      <MenuItem key={type.id}>
                        <Checkbox
                          checked={!!type.checked}
                          onChange={() => toggleType(type.id)}
                        />
                        <ListItemText primary={type.name} />
                      </MenuItem>
                    ));
                  })()}
                </Box>
              </Menu>
              </>
            }

          {!all &&
            <>
              <Button variant='outlined' ref={refcategory} onClick={()=>setOpencategory(!openCategory)}>
                Job Types
              </Button>
      
              <Menu         
              open={Boolean(openCategory)}
              anchorEl={refcategory.current}
              onClose={()=>setOpencategory(false)}
              PaperProps={{
                sx: { minWidth: 50, maxWidth: '100%' }
              }}
              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              >
                <Box sx={{ p: 2, pb: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Search job types..."
                    value={jobTypesSearchTerm}
                    onChange={(e) => setJobTypesSearchTerm(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{ 
                      mb: 1,
                    }}
                  />
                  <Divider sx={{ mt: 1 }}/>
                </Box>
                <Box style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {(() => {
                    const filteredCategories = categories?.filter((type) =>
                      type.name?.toLowerCase().includes(jobTypesSearchTerm.toLowerCase())
                    ) || [];
                    
                    if (filteredCategories.length === 0 && jobTypesSearchTerm) {
                      return (
                        <MenuItem disabled sx={{ justifyContent: 'center' }}>
                          <ListItemText 
                            primary="No result found" 
                            sx={{ textAlign: 'center' }}
                          />
                        </MenuItem>
                      );
                    }
                    
                    {/* <MenuItem key={type.id}>
                      <Checkbox
                      // checked={type.checked}
                      // onChange={() => {
                      //   const updatedType = [...categories];
                      //   const item = updatedType.find((item) => item.id === type.id);
                      //   if (item) {
                      //     item.checked = !item.checked;
                      //   }
                      //   setCategories(updatedType);
                      // }}
                      checked={!!type.checked}
                      onChange={() => toggleCategory(type.id)}
                      />
                      <ListItemText primary={type.name} />
                    </MenuItem>           
                  ))} */}
                    return filteredCategories.map((type) => (
                      <MenuItem key={type.id}>
                        <Checkbox
                          checked={!!type.checked}
                          onChange={() => toggleCategory(type.id)}
                        />
                        <ListItemText primary={type.name} />
                      </MenuItem>
                    ));
                  })()}
                </Box>
              </Menu>
            </>
            }

           </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} alignItems="center" justifyContent="space-between">
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <SearchStyle
            sx={{ backgroundColor: '#05191f', height: 40,
              ...(isOverLimit && {
                '& fieldset': {
                  borderColor: theme.palette.error.main + ' !important'
                }
              })
             }}
              value={filterName}
              onChange={handleFilterByName}
              placeholder={`Search ${workSpaceTitle}`}
              startAdornment={
                <InputAdornment position="start">
                  <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              }
            />
              {isOverLimit && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                  Maximum 25 words allowed.
                </Typography>
              )}
          </Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
              <Button variant='outlined' 
                sx={{height:'40px',backgroundColor: dueData?'#1ccaff' :'',color:dueData?"#fff":''}} 
                onClick={handleByDue} endIcon={<Stack> {dueData ? <Visibility /> : <VisibilityOff/>} </Stack>}>
                By Due
              </Button>
              <MobileDateRangePicker
                startText="Filter Date"
                endText="Filter Date"
                value={filterDateValue}
                onChange={(newValue) => {
                  console.log('setFilterDateValue newValue',newValue);
                  setFilterDateValue(newValue);
                }}
                renderInput={(startProps, endProps) => (
                  <>
                    <TextField {...startProps} sx={{ width: 160 }} helperText='Filter By Due Date' label='From Date' size="small" InputLabelProps={{ style: { color: theme.palette.primary.main, borderColor: theme.palette.primary.main } }}/>
                    <Box sx={{ mx: 1, color: theme.palette.primary.main }}> - </Box>
                    {/* <Box sx={{ mx: 2 }}> to </Box> */}
                    <TextField {...endProps} sx={{ width: 150 }}  helperText='' label='To Date' size="small" InputLabelProps={{ style: { color: theme.palette.primary.main, borderColor: theme.palette.primary.main } }}/>
                  </>
                )}
              />
              <Stack>
                <Button
                  ref={refSort}
                  onClick={() => setSortOpen((prevState) => !prevState)}
                  disabled={dueData}
                  variant="outlined"
                  type="button"
                  endIcon={
                    <Stack>
                      {sortOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                    </Stack>
                  }
                >
                  {sort.label}
                </Button>
                  {dueData && (
                    <FormHelperText sx={{ color: 'error.main', fontSize: '0.65rem', mt: 0.5 }}>
                      Disable "By Due" to enable this.
                    </FormHelperText>
                  )}
                <Menu
                  open={Boolean(sortOpen)}
                  anchorEl={refSort.current}
                  onClose={() => setSortOpen(false)}
                  PaperProps={{
                    sx: { width: 'auto', maxWidth: '100%', maxHeight: '250px' },
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  {SORT.map((category) => (
                    <MenuItem key={category.id} onClick={() => handleChangeSortJobs(category)}>
                      <ListItemText primary={category.label} />
                    </MenuItem>
                  ))}
                </Menu>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        {(filterClient.length > 0 && !all) &&
            <>
              <Button
                variant='outlined'
                sx={{
                  color: 'white',
                  borderColor: 'primary.main',
                  pointerEvents: 'none',
                  userSelect: 'text',
                  marginRight: 2,
                  marginTop: 2
                }}
              >
                <span style={{ color: theme.palette.primary.darker,marginRight:8 }}>Selected Clients </span>
                {clientData
                  .filter(client => filterClient.includes(client.id))
                  .map(client => client.name)
                  .join(', ')
                }
              </Button>
            </>
          }
        {(filterUser.length > 0 && !all )&&
          <>
            <Button
              variant='outlined'
              sx={{
                color: 'white',
                borderColor: 'primary.main',
                pointerEvents: 'none',
                userSelect: 'text',
                marginRight: 2,
                marginTop: 2
              }}
            >
              <span style={{ color: theme.palette.primary.darker,marginRight:8 }}>Selected Users </span>
              {userData
                .filter(user => filterUser.includes(user.id))
                .map(user => user.userName || user.person_name || user.name || user.email)
                .join(', ')
              }
            </Button>
          </>
        }

{
          (filterDepartment.length > 0 && !all) &&
          <>
            <Button
              variant='outlined'
              sx={{
                color: 'white',
                borderColor: 'primary.main',
                pointerEvents: 'none',
                userSelect: 'text',
                marginRight: 2,
                marginTop: 2
              }}
            >
              <span style={{ color: theme.palette.primary?.darker,marginRight:8 }}>Selected Departments </span>
              {departmentsData
                .filter(department => filterDepartment?.includes(department.id))
                .map(department => department.name)
                .join(', ')
              }
            </Button>
          </>
        
        }

        {/* {filterCommunity.length > 0 &&
          <>
            <Typography variant="h6" sx={{ marginTop: 2, marginBottom: 2 }}>
              <span style={{ color: theme.palette.primary.darker }}>Selected Projects : </span>
              {communitiesData
                .filter(community => filterCommunity.includes(community.id))
                .map(community => community.name)
                .join(', ')
              }
            </Typography>
            <Button
              variant='outlined'
              sx={{
                color: 'white',
                borderColor: 'primary.main',
                pointerEvents: 'none',
                userSelect: 'text',
              }}
            >
              <span style={{ color: theme.palette.primary.darker,marginRight:8 }}>Selected Projects </span>
              {communitiesData
                .filter(community => filterCommunity.includes(community.id))
                .map(community => community.name)
                .join(', ')
              }
            </Button>
          </>
        } */}
        {all ? (
          <>
            <InfiniteScroll
          next={onScroll}
          hasMore={hasMore}
          loader={SkeletonLoad}
          dataLength={posts.length}
          style={{ overflow: 'inherit' }}
        >
          <Grid container spacing={3}>
            {data?.map((post, index) => (
              // <BlogPostCard key={post.id} post={post} index={index} />
              <Grid key={index} item xs={12} sm={6} md={4}>
              <UserCard medal={post.status === 0 || post.status === 1 ? 'https://signwisesolutions.com/uploads/ranks/super.png' : post.status !== 0 && post.status !== 1 && post.status !== 3 ? '/static/icons/great.png' : 'https://signwisesolutions.com/uploads/ranks/regular.png'} handleFetchEditData={handleFetchEditData} setIsEdit={setIsEdit} user={post} communityJob={true} />
            </Grid>
            ))}
          </Grid>
          </InfiniteScroll>
            
            <Stack spacing={2} sx={{ mt: 2, width: '100%', alignItems: 'flex-start' }}>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[6, 12, 24, 48]}
              labelRowsPerPage="Rows per page:"
              labelDisplayedRows={({ from, to, count }) => 
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
              }
              sx={{
                width: '100%',
                '& .MuiTablePagination-root': {
                  color: 'white',
                },
                '& .MuiTablePagination-selectLabel': {
                  color: 'white',
                },
                '& .MuiTablePagination-displayedRows': {
                  color: 'white',
                },
                '& .MuiTablePagination-select': {
                  color: 'white',
                },
                '& .MuiTablePagination-selectIcon': {
                  color: 'white',
                },
                '& .MuiTablePagination-actions': {
                  color: 'white',
                },
                '& .MuiTablePagination-toolbar': {
                  color: 'white',
                }
              }}
            />
          </Stack>
          </>
          ):(
        <Scrollbar>
            {/* <Stack sx={{ alignItems: { lg:'center',md:'center' } }} spacing={5}> */}
            <Grid container spacing={2} >
            <Tabs
              value={currentTab}
              scrollButtons="auto"
              variant="scrollable"
              allowScrollButtonsMobile
              onChange={handleChangeTab}   
              sx={{mb:2.5}}      
            >
              {ACCOUNT_TABS.map((tab) => (
                <Tab  sx={{
                  justifyContent: 'center', 
                  marginX: 6, 
                  mt: 2.5,
                  overflow:'visible'
                }}
                disableRipple
                key={tab.value}
                label={
                 // <Badge badgeContent={tab.count} color="primary" max={9999} showZero>
                    <Typography variant="overline">{capitalCase(tab.value)}</Typography>
                 // </Badge>
                }
                icon={tab.icon}
                value={tab.value}
              />
              ))}
            </Tabs>
  
            {ACCOUNT_TABS.map((tab) => {
            const isMatched = tab.value === currentTab;
  
        return isMatched && value === 'one' ?
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
              {tab.component}
          </Box>
          : (isMatched && value === 'three') ?
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
                  {tab.listComponent}
              </Box>
              : (isMatched && value === 'two') ?
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
                 {tab.GridListComponent}
              </Box> : '';
            })}
   </Grid>
          
          {/* Pagination Component for Tabbed View */}
          <Stack spacing={2} sx={{ mt: 2, width: '100%', alignItems: 'flex-start' }}>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[6, 12, 24, 48]}
              labelRowsPerPage="Rows per page:"
              labelDisplayedRows={({ from, to, count }) => 
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
              }
              sx={{
                width: '100%',
                '& .MuiTablePagination-root': {
                  color: 'white',
                },
                '& .MuiTablePagination-selectLabel': {
                  color: 'white',
                },
                '& .MuiTablePagination-displayedRows': {
                  color: 'white',
                },
                '& .MuiTablePagination-select': {
                  color: 'white',
                },
                '& .MuiTablePagination-selectIcon': {
                  color: 'white',
                },
                '& .MuiTablePagination-actions': {
                  color: 'white',
                },
                '& .MuiTablePagination-toolbar': {
                  color: 'white',
                }
              }}
            />
          </Stack>
          {/* </Stack> */}
        </Scrollbar>
        )}
        
        </>
        ):(
          <AddProject singleProjectData={isEdit ? singleProjectData : null} setRenderCards={setRenderCards} isEdit={isEdit} setIsEdit={setIsEdit} setAdd={setAdd}/>
        )}
      </Container>
    </Page>
  );
}
